import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories, articles } from '@/mocks/data';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug);
  const [activeSlug, setActiveSlug] = useState(slug || '');

  useEffect(() => {
    if (slug) setActiveSlug(slug);
  }, [slug]);

  const filteredArticles = articles.filter((a) => a.category === activeSlug);

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <div className="bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: currentCategory?.name || '分类' },
              ]}
            />

            <div className="mt-6">
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                {currentCategory?.name || '分类'}
              </h1>
              <p className="mt-2 text-foreground-500 text-sm md:text-base">
                {currentCategory?.description || '浏览该分类下的所有文章'}
              </p>
            </div>

            <div className="mt-6 flex flex-wrap gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    activeSlug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-50 text-foreground-600 hover:bg-background-200/70 border border-background-200/70'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            {filteredArticles.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {filteredArticles.map((article) => (
                  <ArticleCard key={article.id} {...article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto rounded-full bg-background-100 flex items-center justify-center mb-4">
                  <i className="ri-file-list-3-line text-2xl text-foreground-300" />
                </div>
                <p className="text-foreground-500">该分类下暂无文章</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}